import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from "../../Components/Button/Button.jsx";
import "./Dashboard.css"; 
import EmployeeSelection from './EmployeeSelection.jsx';
import Modal from '../../Components/Modal/Modal.jsx';
import { uploadResume } from '../../Api/apiService.js';
import { ToastContainer, toast } from 'react-toastify';

const UploadEmployee = ({closeuploadModal}) => {
    const [role, setRole] = useState('');
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(false);

    const handleRoleChange = (event) => {
        setRole(event.target.value);
    };

    
    const navigate = useNavigate();
    const handleEmployee = () => {
        console.log('employee Selection ')
        setSelectedEmployeeId(true)
        
    }
    const handleCandidate = () => {
        document.getElementById("resume").click()
    }
    const closeModal = () => {
        setSelectedEmployeeId(false);
    }

     const handleUploadResume = async (e) => {
        e.preventDefault();
        const selectedFile = e.target.files[0];
        
        
        if (!selectedFile) {
          toast.error("Please select a file to upload.", {
            autoClose: 2000,
          });
          return;
        }
        const profileId = window.localStorage.getItem("profileId");
        const formData = new FormData();
        formData.append("resume", selectedFile);
        if(selectedEmployeeId){
            formData.append("userId", profileId);
            formData.append("role", "ROLE_EMPLOYEE");
        }
        
    
        try {
          const response = await uploadResume(formData);
          if (response?.status === 200 || response?.status === 201) {
            toast.success(response?.data?.message || "PDF Resume uploaded successfully!", {
              autoClose: 2000,
            });
           
              closeuploadModal();
              window.localStorage.removeItem("selectedEmployeeId");
              window.localStorage.removeItem("selectedRole");
              window.localStorage.removeItem("profileId");
              selectedEmployeeId ? navigate("/employeeResumeList") :  navigate("/candidateResumeList");
             
          }
        } catch (error) {
          toast.error(error?.response?.data?.message || "Something went wrong.", {
            autoClose: 2000,
          });
        }
      };

    return (
        <>
         <label className="form-field-label" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
          Upload resumes for
        </label>
        <div className="view-resume-btn">
          <Button className="view-resume-buttons" onClick={handleEmployee}>
            Employee
          </Button>
          <Button className="view-resume-buttons" onClick={handleCandidate}>
            Candidate
          </Button>
          <input id="resume" type="file" accept="application/pdf" style={{ display: "none" }} onChange={handleUploadResume} />
        </div>

        {selectedEmployeeId && (
          
            <EmployeeSelection closeModal={closeModal}  />
          
        )}
        
        </>
    );
};

export default UploadEmployee;